// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-toolbar {
  --background: white;
}
.header-toolbar ion-button ion-icon {
  font-size: 2.3rem;
}
.header-toolbar .logo::part(logo-wrapper) {
  height: auto;
}
.header-toolbar .logo::part(logo) {
  width: 75px;
  height: 75px;
}

.content {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
}
.content .malfunction-and-campus {
  display: flex;
  flex: 1;
}
.content .slider-section {
  margin-top: 5rem;
  padding-bottom: 2rem;
  background-color: var(--ion-color-primary);
}
.content .slider-section .swiper {
  height: calc(100% + 2rem);
  top: -2rem;
  max-height: calc(300px + 2rem);
  padding-bottom: 2rem;
  margin-bottom: -2rem;
}
.content .slider-section .swiper-slide .wrapper {
  height: 100%;
}
.content .slider-section .swiper-slide .wrapper img {
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}
.content .slider-section .swiper-pagination {
  bottom: -3px;
}
.content .slider-section .swiper-pagination-bullet {
  background: white;
  width: 50px;
  border-radius: 5px;
  height: 5px;
}
.content .malfunctions-section {
  overflow-y: scroll;
  height: 100%;
  flex: 1;
}
.content .malfunctions-section h1 {
  margin: 0;
  padding: 16px 0;
  margin-bottom: 8px;
}
.content .malfunctions-section::-webkit-scrollbar {
  -webkit-appearance: none;
          appearance: none;
  width: 25px;
}
.content .malfunctions-section::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: rgba(134, 142, 152, 0.4);
  border: 10px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
}
.content .malfunctions-section::-webkit-scrollbar-track {
  margin: 1.5rem;
}
.content .malfunctions-section .malfunctions-list-item {
  --padding-start: 0;
  --inner-padding-end: 0;
  cursor: pointer;
  margin: 0.7rem 0;
}
.content .malfunctions-section .malfunctions-list-item .malfunction {
  background-color: var(--ion-color-light-shade);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  border-radius: 10px;
  width: 100%;
}
.content .malfunctions-section .malfunctions-list-item .malfunction .state-number {
  margin-right: 1rem;
}
.content .malfunctions-section .malfunctions-list-item .malfunction .car-model {
  background-color: white;
  border-radius: 3px;
  padding: 5px;
  margin-right: 1rem;
  white-space: pre;
}
.content .malfunctions-section .malfunctions-list-item .malfunction .text {
  flex: 80%;
  font-size: 0.9rem;
  line-height: 1rem;
  word-break: break-word;
}
.content .malfunctions-section .malfunctions-list-item .malfunction .right-arrow-icon {
  font-size: 2rem;
}
.content .events-section {
  background-color: var(--ion-color-brand);
  position: relative;
  height: 100%;
  flex: 2;
}
.content .events-section .background-images {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.content .events-section .background-images .image {
  position: absolute;
}
.content .events-section .background-images .image:nth-child(1) {
  left: 0;
  top: 80px;
}
.content .events-section .background-images .image:nth-child(2) {
  right: 0;
  top: 160px;
  transform: scale(-1.1, 1.1);
}
.content .events-section .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
}
.content .events-section .header-label {
  font-size: 1.5rem;
  font-weight: 500;
}
.content .events-section .header-buttons .all-materials-button {
  --color: black;
  --border-radius: 5px;
  font-size: 0.8rem;
  text-transform: none;
  margin-right: 10px;
}
.content .events-section .header-buttons .calendar-button {
  --padding-start: 0;
  --padding-end: 0;
  font-size: 1.2rem;
}
.content .events-section .events-list {
  padding: 0;
  background-color: transparent;
}
.content .events-section .events-list .event-item-wrapper {
  --background: transparent;
  --padding-start: 0;
  --padding-end: 0;
  --inner-padding-start: 0;
  --inner-padding-end: 0;
  color: var(--ion-color-light);
  align-items: baseline;
}
.content .events-section .events-list .event-item-wrapper .event-type-title {
  display: flex;
  align-items: baseline;
}
.content .events-section .events-list .event-item-wrapper .event-type {
  font-size: 0.65rem;
  font-weight: 500;
  color: #fff;
  background-color: var(--ion-color-custom-orange);
  border-radius: 1rem;
  padding: 3px 7px;
  white-space: nowrap;
}
.content .events-section .events-list .event-item-wrapper .event-title {
  font-size: 0.9rem;
}
.content .events-section .events-list .event-item-wrapper .event-date-time {
  display: flex;
  align-items: end;
  font-size: 0.8rem;
  font-weight: 700;
  flex-direction: column;
}
.content .events-section .events-list .event-item-wrapper .desktop-event-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.content .events-section .events-list .event-item-wrapper .desktop-event-item .event-date-time {
  margin-right: 10px;
}
.content .events-section .events-list .event-item-wrapper .desktop-event-item .event-type {
  margin-right: 10px;
}
.content .events-section .materials-list {
  display: flex;
  margin-bottom: 1rem;
}
.content .events-section .materials-list-item {
  z-index: 1;
  width: 25%;
  margin: 0 10px;
  cursor: pointer;
}
.content .events-section .materials-list-item:first-child {
  margin-left: 0;
}
.content .events-section .materials-list-item:last-child {
  margin-right: 0;
}
.content .events-section .materials-list-item .img-wrapper {
  width: 100%;
  height: 100%;
}
.content .events-section .materials-list-item .img-wrapper .img-empty {
  align-items: center;
  background: var(--ion-color-light-shade);
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
  border-radius: 1rem;
}
.content .events-section .materials-list-item .img-wrapper .img-empty ion-icon {
  font-size: 2.5rem;
  opacity: 0.7;
}
.content .events-section .materials-list-item .img-wrapper .img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 1rem;
}

@media (max-width: 1199px) {
  .content .slider-section {
    margin-top: 2rem;
    padding-bottom: 0;
  }
  .content .slider-section .swiper-pagination {
    bottom: 10px;
  }
  .content .malfunctions-section {
    flex: none;
    max-height: 250px;
    height: auto;
  }
  .content .malfunction-and-campus {
    flex-direction: column;
  }
}
@media (max-width: 470px) {
  .content .slider-section {
    height: 30%;
  }
  .content .slider-section.ios {
    height: 40%;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
